import React from 'react';
import { connect } from 'react-redux';
import { useAreBothPartiesCurrentlyReceiving } from '../../FinancialPlanOPL/Goals/goals/Retirement/tabs/SocialSecurity/useAreBothPartiesCurrentlyReceiving';
import { selectedInsuranceTypeOrDefaultSelector } from '../../FinancialPlan/Insurance/InsuranceSelector';
import {
  goalId as selectedGoalId,
  selectedGoalSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { fetchGoalWhatIfData, removeWhatIfs } from '../WhatIfsActions';
import { RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS } from '../WhatIfsConstants';
import {
  loading,
  whatIfsSectionsSelector,
  nullableUrlSelector,
  nullableFpIdSelector,
} from '../WhatIfsSelector';
import View from './WhatIfMenuView';

const mapStateToProps = (state, ownProps) => ({
  loading: loading(state, ownProps),
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  url: nullableUrlSelector(state, ownProps),
  whatIfsSections: whatIfsSectionsSelector(state, ownProps),
  selectedInsuranceType: selectedInsuranceTypeOrDefaultSelector(state, ownProps),
  goalData: selectedGoalSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  fetchData: (clientId, fpId, goalId, url, debtType) => {
    dispatch(fetchGoalWhatIfData(clientId, fpId, goalId, url, debtType));
  },
  removeWhatIf: (clientId, fpId, goalId, url, whatIf, debtType) => event => {
    event.stopPropagation();
    dispatch(removeWhatIfs(clientId, fpId, goalId, url, [whatIf.WhatIf.WhatIfKey], debtType));
  },
});

const WhatIfMenuWithSsGate = props => {
  const hideSocialSecurity = useAreBothPartiesCurrentlyReceiving();
  const whatIfsSections = hideSocialSecurity
    ? Object.fromEntries(
        Object.entries(props.whatIfsSections || {}).map(([key, items]) => [
          key,
          (items || []).filter(
            item => item?.WhatIf?.WhatIfType !== RETIREMENT_SOCIAL_SECURITY_MONTHLY_BENEFITS,
          ),
        ]),
      )
    : props.whatIfsSections;

  return <View {...props} whatIfsSections={whatIfsSections} />;
};

const WhatIfMenuContainer = connect(mapStateToProps, mapDispatchToProps)(WhatIfMenuWithSsGate);

export default WhatIfMenuContainer;
